import { useCallback, useEffect } from 'react';
import { useWorkspaceWindow } from '../context/WorkspaceWindowContext';

/**
 * Mark the current workspace window as having unsaved changes.
 * Closing the window will prompt Save / Discard / Cancel.
 */
export function useWorkspaceDirty(label = 'Unsaved changes') {
  const ctx = useWorkspaceWindow();

  const markDirty = useCallback(() => {
    ctx?.setDirty?.(label);
  }, [ctx, label]);

  const markClean = useCallback(() => {
    ctx?.clearDirty?.();
  }, [ctx]);

  useEffect(() => () => {
    ctx?.clearDirty?.();
  }, [ctx]);

  return { markDirty, markClean, isSupported: Boolean(ctx?.setDirty) };
}